import { useCallback, useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import ConsumerParametersEditor from "./ConsumerParametersEditor";

// Register another section here only after its calculation path supports these settings.
const consumers = [{ id: "marketwatch", title: "مارکت‌واچ" }];

export default function ConsumerParametersTab({ onDirtyChange }: { onDirtyChange: (dirty: boolean) => void }) {
  const [consumerId, setConsumerId] = useState(consumers[0].id);
  const [dirty, setDirty] = useState(false);
  const consumer = consumers.find(item => item.id === consumerId)!;
  const changeDirty = useCallback((next: boolean) => {
    setDirty(next);
    onDirtyChange(next);
  }, [onDirtyChange]);

  return <div className="grid gap-4 lg:grid-cols-[180px_minmax(0,1fr)]">
    <nav aria-label="بخش‌های سامانه" className="self-start rounded-lg border border-slate-200 bg-white p-2">
      <div className="px-3 pb-3 pt-2 text-xs font-semibold text-slate-500">بخش سامانه</div>
      {consumers.map(item => <button key={item.id} type="button" disabled={dirty}
        aria-current={consumerId === item.id ? "page" : undefined} onClick={() => setConsumerId(item.id)}
        className={`flex w-full items-center justify-between rounded-md px-3 py-2.5 text-xs transition-colors focus-visible:outline-sky-600 disabled:cursor-default ${consumerId === item.id ? "bg-sky-50 font-semibold text-sky-700" : "text-slate-600 hover:bg-slate-50"}`}>
        {item.title}<RightOutlined aria-hidden="true" className="rotate-180 text-[10px]" />
      </button>)}
    </nav>
    <ConsumerParametersEditor key={consumer.id} consumer={consumer} onDirtyChange={changeDirty} />
  </div>;
}
